import { useEffect, memo, useState } from 'react'
import Context from './Context'
import Layout from './Layout'
import useCreateStore from './useCreateStore'
import useFetchData from './useFetchData'
import useLogNavigation from 'hooks/useLogNavigation'

const Users: React.FC = memo(() => {
  useLogNavigation("Manejo de usuarios y soporte: Usuarios")
  const [display, setDisplay] = useState(false)
  const [states, actions] = useCreateStore()
  const queryHandler = useFetchData(states, actions)

  const props = {
    value: { states, actions, queryHandler }
  }

  useEffect(() => {
    return () => {
      queryHandler.remove()
    }
  }, [])

  return (
    <Context.Provider {...props}>
      <Layout />
    </Context.Provider>
  )
})

export default Users
